<specs-lot-addendum-view
  [lotId]="lotId()"
  [modelId]="modelId()"
  [elevationId]="elevationId()"
></specs-lot-addendum-view>
